<script>
  import {
    currentLocation,
    pathTrappe,
    choix,
    sensOuverture,
    fermeture,
    type,
    couleur,
    epaisseur,
    dimLongueurIdFiche,
    dimLargeurIdFiche,
    sensOuvertureIdFiche,
    fermetureIdFiche,
    typeIdFiche,
    couleurIdFiche,
    epaisseurIdFiche,
    trappePath,
  } from '../stores.js';
  import { useNavigate } from 'svelte-navigator';
  export let idFiche;
  export let idBtn;
  export let titre;
  export let soustitre;
  let ral = 1000;
  console.log(`btn Alu ${idFiche}`);
  const navigate = useNavigate();

  //--- New Add
  import Modal, { getModal } from '../Components/Modal.svelte';
  function getRal() {
    getModal('ral').close();
    $couleur = 'RAL(' + ral + ')';
    $couleurIdFiche = 5;
    pathTrappe.add($currentLocation, ['couleur', 'couleurIdFiche']);
    navigate('/recapitulatif');
  }
  function closeModal() {
    getModal('ral').close();
  }
  //--- New Add

  function pageNext() {
    $trappePath = [...$trappePath, idBtn];
    if (idBtn == 5 || idBtn == 6 || idBtn == 7) {
      $choix = idBtn;
    }
    if (idBtn == 8 || idBtn == 9 || idBtn == 10) {
      $choix += idBtn;
    }
    if (idBtn == 1) {
      $type = 'Mur';
      $typeIdFiche = 1;
      pathTrappe.add($currentLocation, ['type', 'typeIdFiche']);
    }
    if (idBtn == 2) {
      $type = 'Plafond';
      $typeIdFiche = 1;
      pathTrappe.add($currentLocation, ['type', 'typeIdFiche']);
    }
    if (idBtn == 3 || idBtn == 4) {
      $sensOuverture = titre;
      $sensOuvertureIdFiche = 3;
      pathTrappe.add($currentLocation, [
        'sensOuverture',
        'sensOuvertureIdFiche',
      ]);
    }

    if (idBtn == 5) {
      $fermeture = 'Pousser / Lâcher';
      $fermetureIdFiche = 4;
      pathTrappe.add($currentLocation, ['fermeture', 'fermetureIdFiche']);
    }
    if (idBtn == 6) {
      $fermeture = 'Clé carrée';
      $fermetureIdFiche = 4;
      pathTrappe.add($currentLocation, ['fermeture', 'fermetureIdFiche']);
    }
    if (idBtn == 7) {
      $fermeture = 'Clé boite aux lettres';
      $fermetureIdFiche = 4;
      pathTrappe.add($currentLocation, ['fermeture', 'fermetureIdFiche']);
    }

    // if (idBtn == 8) {
    //   $couleur = titre;
    // }
    // if (idBtn == 9) {
    //   $couleur = titre;
    // }
    // if (idBtn == 10) {
    //   $couleur = 'RAL('+ral+')';
    // }

    if (idFiche < 4) {
      let next = parseInt(idFiche) + 1;
      navigate('/LayoutPage/' + next);
    } else {
      navigate('/recapitulatif');
    }

    // if (idFiche == 2) {
    //   if (idBtn == 1) {
    //     $sensOuverture = 'Longueur';
    //   } else {
    //     $sensOuverture = 'Largeur';
    //   }
    //   let next = parseInt(idFiche) + 1;
    //   navigate('/LayoutPage/' + next);
    // } else {
    //   if (idBtn == 1) {
    //     $fermeture = 'Pousser / Lâcher';
    //   } else if (idBtn == 2) {
    //     $fermeture = 'Clé carrée';
    //   } else {
    //     $fermeture = 'Clé boite aux lettres';
    //   }
    //   navigate('/recapitulatif');
    // }
  }
</script>

<Modal id="ral">
  <div class="as-modal-wrapper">
    <div class="as-titre mb-4" style="z-index:100">Choisissez votre RAL</div>
    <div class="flex flex-wrap items-stretch w-full mb-4 relative">
      <div class="flex -mr-px">
        <span
          class="flex items-center leading-normal bg-grey-lighter rounded rounded-r-none border border-r-0 border-grey-light px-3 whitespace-no-wrap text-grey-dark text-sm"
          style="border-color: #000;color: #000;">RAL</span
        >
      </div>
      <input
        bind:value="{ral}"
        midn="1000"
        max="9999"
        type="text"
        class="flex-shrink flex-grow flex-auto leading-normal w-px  border h-10 border-grey-light rounded px-3 relative"
        style="border-color: #000;color: #838383;max-width:600px;"
      />
    </div>

    <div class="w-full grid grid-flow-col grid-cols-6 gap-4 align-bottom">
      <div class="col-span-4  text-sm " style="">
        <span
          on:click="{() => closeModal()}"
          class="as-btn-rounded as-btn-cancel">Annuler</span
        >
      </div>

      <div class="col-span-2 text-right flex justify-end items-end">
        <button
          on:click="{() => getRal()}"
          class="as-btn-rounded"
          style="margin-top: 10px;"
        >
          valider
        </button>
      </div>
    </div>
  </div>
</Modal>

{#if idBtn == 10}
  <button on:click="{() => getModal('ral').open()}" class="as-btn-choix">
    <div class="as-square-choix ">
      {@html titre}
      {#if soustitre}
        <p class="text-left text-lg font-light mt-2 ">
          {soustitre}
        </p>
      {/if}
    </div>
  </button>
{:else}
  <button on:click="{() => pageNext()}" class="as-btn-choix">
    <div class="as-square-choix ">
      {@html titre}
      {#if soustitre}
        <p class="text-left text-lg font-light mt-2 ">
          {soustitre}
        </p>
      {/if}
    </div>
  </button>
{/if}

<!-- 
<div
  class="relative flex flex-col min-w-0 break-words mb-6 w-full  shadow-lg rounded-lg  bg-white transition duration-300 transform hover:scale-105 group hover:shadow-xl"
  aria-label="View item"
  title="View item"
>
  <blockquote class="relative p-6 w-full">
    <div class="w-full grid grid-cols-12 gap-4">
      <div class="col-span-9  flex self-center flex-col ">
        <h4 class="text-left text-xl font-bold text-seminBlue">{titre}</h4>
        {#if idBtn == 10}
          <div class="flex flex-wrap items-stretch w-full mb-4 relative">
            <div class="flex -mr-px">
              <span
                class="flex items-center leading-normal bg-grey-lighter rounded rounded-r-none border border-r-0 border-grey-light px-3 whitespace-no-wrap text-grey-dark text-sm"
                style="border-color: #94bdd7;color: #104c77;">RAL</span
              >
            </div>
            <input
              bind:value="{ral}"
              min="1000"
              max="9999"
              type="text"
              class="flex-shrink flex-grow flex-auto leading-normal w-px  border h-10 border-grey-light rounded px-3 relative"
              style="border-color: #94bdd7;color: #838383;max-width:100px;"
            />
          </div>
        {/if}
        {#if soustitre}
          <p class="text-left text-lg font-light mt-2 ">
            {soustitre}
          </p>
        {/if}
      </div>

      <button on:click="{() => pageNext()}" class="as-btn-choix">
        <div class="as-square-choix ">
          {@html titre}
          {#if soustitre}
            <p class="text-left text-lg font-light mt-2 ">
              {soustitre}
            </p>
          {/if}
        </div>
      </button>

      <div class="col-span-3 text-right  flex self-center">
        <button
          on:click="{() => pageNext()}"
          class="get-started mt-4 px-6 py-4 rounded outline-none focus:outline-none mr-1 mb-1 bg-seminYellow uppercase text-sm shadow hover:shadow-lg ease-linear transition-all duration-150"
        >
          Choisir
          <svg
            class="inline -mt-1 w-3 text-gray-700 transition-colors duration-300 group-hover:text-indigo-600"
            fill="currentColor"
            viewBox="0 0 12 12"
          >
            <path
              d="M9.707,5.293l-5-5A1,1,0,0,0,3.293,1.707L7.586,6,3.293,10.293a1,1,0,1,0,1.414,1.414l5-5A1,1,0,0,0,9.707,5.293Z"
            ></path>
          </svg>
        </button>
      </div>
    </div>
  </blockquote>
</div> -->
